import { apiSlice } from "../../apiSlice";

/* -------------------- Mutation Slice -------------------- */
export const bulkDealsSpareMutationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    /* -------------------- REJECT -------------------- */
    rejectBulkDealRequest: builder.mutation({
      query: ({ request_id, remarks }) => ({
        url: "/bulk_deals/spares",
        method: "PATCH",
        params: { request_id, status: 2, remarks },
      }),

      async onQueryStarted({ request_id, remarks }, { dispatch, queryFulfilled }) {

        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getBulkDealsSparesList",
            {},
            (draft) => {
              const item = draft.entities[request_id];

              if (item) {
                item.status = 2;
                item.remarks = remarks;
                item.approval_status = "rejected";
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo();
          console.error("Reject bulk deal request failed:", err);
        }
      },
    }),

    /* -------------------- APPROVE -------------------- */
    approveBulkDealRequest: builder.mutation({
      query: ({ request_id }) => ({
        url: "/bulk_deals/spares",
        method: "PATCH",
        params: { request_id, status: 1 },
      }),

      async onQueryStarted({ request_id }, { dispatch, queryFulfilled }) {

        const patchResult = dispatch(
          apiSlice.util.updateQueryData(
            "getBulkDealsSparesList",
            {},
            (draft) => {
              const item = draft.entities[request_id];

              if (item) {
                item.status = 1;
                item.approval_status = "approved";
              }
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (err) {
          patchResult.undo();
          console.error("Approve bulk deal request failed:", err);
        }
      },
    }),

  }),
});

export const {
  useRejectBulkDealRequestMutation,
  useApproveBulkDealRequestMutation,
} = bulkDealsSpareMutationApiSlice;